export enum EntityType {
  OBJET_COMPTE = "OBJET_COMPTE",
  SOURCE_REVENU = "SOURCE_REVENU",
  PAYS = "PAYS",
  PROFESSION = "PROFESSION",
  ACTIVITE = "ACTIVITE",
  PRODUIT = "PRODUIT",
  CANAL = "CANAL",
  ANNEE_CONSTITUTION = "ANNEE_CONSTITUTION",
}

export enum RiskLevel {
  RE = "RE",
  RM = "RM",
  RF = "RF",
}

export interface RiskEntityCode {
  id: string;
  type: EntityType;
  code: string;
  libelle: string;
  level: RiskLevel;
  active: boolean;
  lastModifiedAt: string;
  lastModifiedBy: string;
}

export interface RiskEntityCodeResponse {
  items: RiskEntityCode[];
  totalElements: number;
}

export interface RiskEntityFilters {
  search?: string;
  level?: RiskLevel | "";
  page?: number;
  size?: number;
}

export interface RiskEntityTypeStats {
  type: EntityType;
  count: number;
  lastModifiedAt: string;
}
